function BasePolicyFormCtrl($scope, $controller, $location, $timeout, rulesDef, $state, $filter, IconsService, GeneralUtilsService, NetworkRulesService) {

    $controller('SecurityCtrl', {$scope: $scope, $location:$location, $timeout:$timeout, $state: $state, GeneralUtilsService: GeneralUtilsService});

    var icons = IconsService.getIcons("policy");

    $scope.datamodified = false;
    $scope.exceptionsdatamodified = false;

    $scope.parseTrafficData = function(dataItems){
        dataItems.forEach(function(dataItem){
            dataItem.pcapLastModifiedMoment = $filter('timeToMoment')(dataItem.pcapLastModifiedTimestamp);
            dataItem.pcapCount = dataItem.pcapCount ? $filter('number')(dataItem.pcapCount, 0)  : "";

            dataItem.source.forEach(function(item) {
            	if(item.entityType === "OS"){
            		item.display_name = $scope.osMapping[item.name] || item.name;
            	}
            });

        });
        return dataItems;
    };

    $scope.configs = {"site": {"config":"sitesConfig", "type":"entity"},
        "accesslogin": {"config":"accessloginsConfig", "type":"entity"},
        "group": {"config":"groupsConfig", "type":"entity"} ,
        "subnet": {"config":"ipRangesConfig", "type":"entity"},
        "floatingipsubnet":{"config":"floatingIpsConfig", "type":"entity"},
        "hostsubnet": {"config":"subnetsConfig", "type":"entity"},
        "interfaceiprange": {"config":"ipRangesConfig", "type":"entity"},
        "networkinterface": {"config":"ipRangesConfig", "type":"entity"},
        "ip": {"config":"ipsConfig", "type":"string"},
        "port": {"config":"portsConfig", "type":"string"},
        "appstring":{"config":"appsConfig", "type":"list"},
        "appcategory":{"config":"categoriesConfig", "type":"entity"},
        "app":{"config":"appsConfig", "type":"entity"},
        "customapp":{"config":"customAppsConfig", "type":"entity"},
        "customcategory":{"config":"customCategoriesConfig", "type":"entity"},
        "service":{"config":"servicesConfig", "type":"entity"},
        "os":{"config":"osConfig", "type":"list"},
        "directoryserviceuser":{"config":"dsUserConfig","type":"entity"},
        "country":{"config":"countriesConfig","type":"entity"},
        "fqdn":{"config":"fqdnConfig","type":"string"},
        "tld":{"config":"tldConfig","type":"string"},
        "systemgroup": {"config":"groupsConfig", "type":"entity"},
        "connectivityruletype": {"config":"connectivityRuleTypesConfig", "type":"entity"},/*
        "singleip": {"config":"singleIpConfig", "type":"string"},*/
    };

    rulesDef["traffic"] =  {
    	generalFetch: true,
    	sortButton: false,
    	destination: "<entry-list items='item.destination' root='item' field='destination' id='destination_{{$parent.$index}}' add-items='tableConfig.selectIpPortAndApp(item,field,id)' icons='tableConfig.icons'></entry-list>",
    	ruleCollection: 'trafficLoggingRules',
    	type: 'TrafficLoggingRule',
    	constraints: ['time'],
        clientSideSearch: false,
    	fields: [
    		{
    			label: 'Description',
    			path: 'lastModified',
    			noSort: false,
    			template: '<div style="max-width:350px;"><div class="ellipsis last-modified" ng-show="item.lastModified"><span class="title">Last Modified: </span><span class="value">{{item.lastModified | date:"medium"}}</span></div> <div class="ellipsis description" ng-show="!showDescriptionInput && item.description" ng-click="showDescriptionInput = true"><span>{{item.description}}</span></div> <div class="description" ng-show="!showDescriptionInput && !item.description" ng-click="showDescriptionInput = true"><span>Add Description</span></div> <textarea ng-show="showDescriptionInput" ng-model="item.description"></textarea></div>',
    			noSearch: true
    		},
    		{
    			class: 'entry-list',
    			label: 'Source',
    			path: 'source',
    			noSort: true,
    			template: "<span><entry-list items='item.source' root='item' field='source' id='source_{{$parent.$index}}' add-items='tableConfig.selectIpPort(item,field,id)' icons='tableConfig.icons'></entry-list></span>"
    		},
    		{
    			class: 'entry-list',
    			label: 'Destination',
    			path: 'destination',
    			noSort: true,
    			template: "<span><entry-list items='item.destination' root='item' field='destination' id='destination_{{$parent.$index}}' add-items='tableConfig.selectIpPortAndApp(item,field,id)' icons='tableConfig.icons'></entry-list></span>"
    		},
    		{
    			label: 'File Size',
    			path: 'fileSize',
    			noSort: true,
    			template: "<span><input type='text' style='width: 50px; text-align:right' ng-model='item.fileSize'/> MB</span>",
    			noSearch: true
    		},
    		{
            	label: 'Record Limit',
            	path: 'limitRecord',
            	noSort: true,
            	template: "<span><input type='text' style='width: 50px; text-align:right' ng-model='item.limitRecord'/> KB</span>",
            	noSearch: true
            },
    		{
    			class: 'toggle-status',
    			noSort: true,
    			label: 'Results',
    			path: 'pcapCount',
    			template: "<div style='padding-left: 15px' tooltip tooltipvalue='item.pcapLastModifiedMoment' >{{item.pcapCount}}</div>",
    			noSearch: true
    		},
    		{
    			class: 'constraint',
    			label: 'Limit to',
    			path: 'constraint',
    			noSort: true,
    			template: "<span><constraint id='tableConfig.constraintName' item='item' config='tableConfig' index='$parent.$index'/></span>",
    			noSearch: true
    		},
    		{
    			class: 'toggle-status',
    			label: 'Enabled',
    			path: 'enabled',
    			template: '<div class="toggle no-disable" ng-show="item.id > 0"> <input id="active-rule-{{$index}}" type="checkbox" chked="item.enabled" chx-toggle/> </div>',
    			noSearch: true
    		},
    	],
    	typeProcessData: function (items) {
    		items.forEach(function (item) {
    			item.fileSize = $filter('toUnit')(item.fileSize, "MB");
    			item.limitRecord = $filter('toUnit')(item.limitRecord, "KB");
    		});
    	},
    	noAutoSelect: true,
    	expand: function (item) {
    		return (item.pcapCount > 0);
    	},
    	expanderClick: true,
    	parseData: $scope.parseTrafficData,
    	dataURL: function () {
    		// var ruleIdParam = $scope.ruleId ? '&ruleId=' + $scope.ruleId : '';
    		return '/trafficLoggingList?type=' + ruleType.toUpperCase() + ($state.params.accountId ? '&accountId=' + $state.params.accountId : '');
    	},
    	innerTable: {
    		showLoader: false,
    		defer: false,
    		noSearch: true,
    		expand: false,
    		hideFacets: true,
    		hideHead: false,
    		expanderClick: true,
    		hideCheckboxes: true,
    		inheritSetting: true,
    		processData: true,
    		showPopUp: true,
    		dataURL: 'innerTableDataURL',
    		customButtons: null,
    		specialActions: null,
    		actions: null,
    		parseData: 'innerTableParseData',
    		fields: [
    			{
    				label: 'Time',
    				path: 'startTime',
    				width: 1,
    				template: '<span><time>{{item.startTime}}</time></span>'
    			},
    			{
    				label: 'Status',
    				noSort: false,
    				path: 'fileStatus',
    				width: 1,
    				template: '<span><span>{{item.fileStatus}}</span></span>'
    			},
    			{label: 'Size', noSort: false, path: 'size', width: 1, template: '<span>{{item.size}}</span>'},
    			{
    				label: 'Download',
    				noSort: false,
    				path: 'download',
    				width: 1,
    				template: "<a href='/downloadLoggingTrafficFile?url={{item.id}}'><div style='padding-left:22px'><span class='glyphicon glyphicon-floppy-save'/></div></a>"
    			},
    		],
    	},
    	innerTableDataURL: function (parent) {
    		// var fromDate = $scope.statsFrom;
    		// var toDate = $scope.statsTo;
    		return '/getLoggingTrafficFiles?ruleId=' + parent.id + '&accountId=' + ($state.params.accountId ? $state.params.accountId : parent.accountId );
    	},
    	innerTableParseData: function (dataItems) {
    		var items = [];
    		dataItems.forEach(function (dataItem) {
    			var tData = {};
    			tData.id = dataItem.fileName;
    			tData.startTime = moment(GeneralUtilsService.getTimeInMiliseconds(dataItem.startTime)).calendar();
    			tData.fileStatus = dataItem.status;
    			tData.size = $filter('toUnit')(dataItem.fileSize,"MB");

    			items.push(tData);
    		});
    		return items;
    	},
    	preSave: function (rule) {
    		rule.fileSize = $filter('fromUnit')(rule.fileSize,"MB");
    		rule.limitRecord = $filter('fromUnit')(rule.limitRecord,"KB");
    	},
    	postSave: function (rule) {
    		rule.fileSize = $filter('toUnit')(rule.fileSize,"MB");
    		rule.limitRecord = $filter('toUnit')(rule.limitRecord,"KB");
    	},
    };

    var ruleDef = rulesDef[$state.current.rule];
    var ruleCollection = ruleDef.ruleCollection;
    var ruleType = ruleDef.type;
    $scope.ruleId = $state.params.ruleId;
    $scope.ruleDef = ruleDef;

    $scope.removeRuleFilters = function(){
        window.location.href = $scope.ruleDef.redirect;
    };


    $scope.$root.hasChanges = function(id){
        if(!$scope.account) return false;
        var rulesChanged;
        if(id) {
            rulesChanged = $("#" + id + " .warning:visible").length > 0 || (ruleDef.enabledAttrib ? $scope.account.enabled !== $scope.account[ruleDef.enabledAttrib] : false);
        }
        else {
            rulesChanged = $(".warning:visible").length > 0 || (ruleDef.enabledAttrib ? $scope.account.enabled !== $scope.account[ruleDef.enabledAttrib] : false);
        }
        return rulesChanged;
    };

    $scope.origRules = {};
    $scope.levels = [2,3,4,5];
    $scope.showItem = 'group';
    $scope.showApp = 'category';
    $scope.showConstraint = ruleDef.constraints[0];
    $scope.selectedRule = null;
    $scope.openedCategories = {};
    $scope.servicesNames = {};
    $scope.categorizedApps = {};
    $scope.selectedCategoiresAndApps = {"categories":[],"apps":[]};
    $scope.timeConstraints = {"type":"always","timeDef":{"isA":"Time","days":[],"times":[],"reoccurring":true}};
    $scope.bwConstraints =  {"download":null};
    $scope.occurrenceConstraint =  {};
    $scope.durationConstraint;


    // Get default file size
    store.fetch({
        path:"/getPropertyValue?property=defaultFileSize",
        success: function(data) {
            data = $filter('bytes')(data,2,false,true);
            $scope.defaultFileSize = data;
        }
    });

    // Get max file size
    store.fetch({
        path:"/getPropertyValue?property=maxFileSize",
        success: function(data) {
            data = $filter('bytes')(data,2);
            $scope.maxFileSize = data;
        }
    });

    $scope.type = ruleDef.type;

    $scope.rulesConfig = {
        id: ruleDef.ruleCollection,
        noLimit: ruleDef.noLimit,
        pageSize: ruleDef.pageSize ? ruleDef.pageSize : null,
        destination: ruleDef.destination,
        types: ruleDef.types,
        typeField: ruleDef.typeField,
        sortButton: ruleDef.sortButton,
        clientSideSort: ruleDef.clientSideSort,
        clientSideSearch: (ruleDef.clientSideSearch === null) ? true : ruleDef.clientSideSearch,
        noCommands: ruleDef.noCommands,
        defer: ruleDef.defer,
        titleSearch: ruleDef.titleSearch,
        ruleAction: ruleDef.defaultAction,
        policy: {},
        filter: true,
        accountId: $state.params.accountId,
        dataURL: ruleDef.dataURL ? ruleDef.dataURL :  function () {
            return false;
        },
        noAutoSelect : ruleDef.noAutoSelect,
        fields : ruleDef.fields,
        preFields: ruleDef.preFields,
        expand : ruleDef.expand,
        innerTable : ruleDef.innerTable,
        expanderClick : ruleDef.expanderClick,
        preSave: ruleDef.preSave,
        postSave : ruleDef.postSave,
        innerTableDataURL : ruleDef.innerTableDataURL,
        innerTableParseData : ruleDef.innerTableParseData,
        //selectIdentifier: ruleDef.selectIdentifier,
        type : "AccessRule",
        actions: [],
        selectedItems:[],
        items:[],
        dirs:{"TO":"--->","BOTH":"<--->"},
        select: function(item,field,id){
            if (item.healthType === 'Quality') {
                $scope.$root.openPopup("addQualityItem");
            } else {
                $scope.$root.openPopup("addItem");
            }
            $scope.currentAction = this.ruleAction;
            this.doSelect(item,field);
        },
        selectApp: function(item,field,id){
            $scope.$root.openPopup("applications");
            var configs = {"appcategory":"categoriesConfig","app":"appsConfig","service":"servicesConfig", "customapp": "customAppsConfig", "customcategory": "customCategoriesConfig", "fqdn": "fqdnConfig", "tld": "tldConfig"};
            $scope.currentAction = this.ruleAction;
            this.doSelect(item,field);
        },
        selectLocation: function(item,field,id){
            $scope.$root.openPopup("configureEgress");
            var configs = {"appcategory":"categoriesConfig","app":"appsConfig","service":"servicesConfig", "customapp": "customAppsConfig", "customcategory": "customCategoriesConfig"};
            $scope.currentAction = this.ruleAction;
            if (item.ruleAction==='ROUTE') {
                $scope.configureEgressShowItem = 'location';
            }
            if (item.ruleAction==='NAT_N_ROUTE') {
                $scope.configureEgressShowItem = 'ip';
            }
            this.doSelect(item,field);
        },
        selectIpPort: function(item,field,id){
            $scope.showTabIpsPorts = 'site';
            var $tablist = $('#addItem').find('.nav-tabs');
            $tablist.find('.active').removeClass('active');
            $tablist.find('li:first').addClass('active');
            $scope.initItemsModal('src', 'site');
            $scope.currentAccountId = item.accountId;
            $scope.currentAction = this.ruleAction;
            $scope.$root.openPopup("addItem");
            this.doSelect(item,field);
        },
        selectIpPortAndApp: function(item,field,id){
            $scope.showTabIpsPortsApps = 'site';
            var $tablist = $('#applications').find('.nav-tabs');
            $tablist.find('.active').removeClass('active');
            $tablist.find('li:first').addClass('active');
            $scope.initItemsModal('dst', 'site');
            $scope.currentAction = this.ruleAction;
            $scope.currentAccountId = item.accountId;
            $scope.$root.openPopup("IpPortAndApp");
            this.doSelect(item,field);
        },
        selectConnectivityRuleType: function(item,field,id){
            $scope.currentAccountId = item.accountId;
            $scope.$root.openPopup("connectivity-rule-type-popup");
            this.doSelect(item,field, true);
        },
        doSelect : function(currItem, field, noAnyField){
            angular.forEach($scope.configs,function(config) {
                if ($scope[config.config]) {
                    if(config.type === "entity" || config.type === "list"){
                        $scope[config.config].selectedItems = [];
                    }
                    else if(config.type === "string"){
                        $scope[config.config].selectedItems = "";
                    }
                }
            });

            var items = currItem[field];
            $timeout(function() {
                if (items) {
                    items.forEach(function(item) {
                        if((noAnyField || item.name != "Any") && item.type){
                            var config = $scope.configs[item.type.toLowerCase()];
                            if(config.type === "entity"){
                                $scope[config.config].selectedItems.push(item);
                            }
                            else if(config.type === "string"){
                                if($scope[config.config].selectedItems.length > 0){
                                    $scope[config.config].selectedItems += ",";
                                }
                                $scope[config.config].selectedItems += item.name;
                            }
                            else if(config.type === "list"){
                                $scope[config.config].selectedItems.push({"id":item.name});
                            }
                        }
                    });
                }

                $scope.scopeSelection = {"item":currItem,"type":field};
            }, 1);

        },
        directions: ruleDef.directions || ['TO', 'BOTH'],
        changeDir: function(item){
            var that = this;
            $timeout(function(){
                for (var i=0;i<that.directions.length;i++) {
                    if(item.dir === that.directions[i]){
                        if (i + 1 < that.directions.length) {
                            item.dir = that.directions[i+1];
                        } else {
                            item.dir = that.directions[0];
                        }
                        break;
                    }
                }
                $('.direction').data('title', item.dir);
            }, 0);
        },
        editTrigger:function(item,id){
            $scope.editTrigger(item,id);
        },
        editConstraints: function(item,id){
            if(ruleDef.constraints.indexOf('service') >= 0 || ruleDef.constraints.indexOf('limit_bw') >= 0 || ruleDef.constraints.indexOf('time') >= 0 ||
                ruleDef.constraints.indexOf('custom_apps') >= 0 || ruleDef.constraints.indexOf('ports') >= 0){
                if(!item.constraint){
                    item.constraint = {"predicates":[],"op":"OP_EQ"};
                }
                if(ruleDef.constraints.indexOf('service') >= 0) {
                    $scope.serviceConstraintConfig.selectedItems = [];
                    if(item.constraint.predicates["appid"]){
                        item.constraint.predicates["appid"].values.forEach(function(value) {
                            if (value.indexOf('CustomApp_') !== 0) {
                                $scope.serviceConstraintConfig.selectedItems.push({"id": value});
                            }
                        });
                    }
                }
                if(ruleDef.constraints.indexOf('custom_apps') >= 0) {
                    $scope.customAppsConfig.selectedItems = [];
                    if(item.constraint.predicates["appid"]){
                        item.constraint.predicates["appid"].values.forEach(function(value) {
                            if (value.indexOf('CustomApp_') === 0) {
                                $scope.customAppsConfig.selectedItems.push({"id":value});
                            }
                        });
                    }
                }
                $scope.timeConstraints = {"type":"always","timeDef":{"isA":"Time","days":[],"times":[],"reoccurring":true}};
                if(item.constraint.predicates["time"]){
                    item.constraint.predicates["time"].values.forEach(function(value) {
                        if(typeof value == "string"){
                            $scope.timeConstraints['type'] = value;
                        }
                        else {
                            $scope.timeConstraints['type'] = "custom";
                            $scope.timeConstraints['timeDef'] = value;
                        }
                    });
                }
                else {
                    $scope.timeConstraints['type'] = 'always';
                }

                $scope.bwConstraints = {"download":null};
                if(item.constraint.predicates["limit_bw"] && item.constraint.predicates["limit_bw"].values[0]){
                    $scope.bwConstraints['download'] = parseInt(item.constraint.predicates["limit_bw"].values[0]);
                }
                else {
                    $scope.bwConstraints['download'] = null;
                }

                if (ruleDef.constraints.indexOf('ports') >= 0) {
                    $scope.portsConstraints = (item.constraint.predicates.server_port? item.constraint.predicates.server_port.values : "") + (item.constraint.predicates.server_port && item.constraint.predicates.ports_range ? "," : "") + (item.constraint.predicates.ports_range ? item.constraint.predicates.ports_range.values : "");
                }
            }
            if (ruleDef.constraints.indexOf('connectivity') >= 0 || ruleDef.constraints.indexOf('quality') >= 0) {
                if (item.healthType === 'Disconnect') {
                    $scope.showConstraint = 'connectivity';
                    $scope.occurrenceConstraint =  {};
                    delete $scope.durationConstraint;
                    if(item.alertConstraint){
                        if(item.alertConstraint.minDown && item.alertConstraint.minDown > 0){
                            $scope.durationConstraint = item.alertConstraint.minDown;
                        }
                        if(item.alertConstraint.occurrenceConstraint){
                            $scope.occurrenceConstraint = item.alertConstraint.occurrenceConstraint;
                        }
                    }
                }
                else if (item.healthType === 'Quality') {

                    $scope.showConstraint = 'quality';

                    $scope.qualityConstraint = item.alertConstraint.qualityConstraint;
                }
            }

            $scope.scopeSelection = {"item":item};

            $scope.$root.openPopup("constraintEditor");
        },
        getThresholdsSummary: function(thresholds) {
            var summary = '';
            if (thresholds && thresholds.target)
                summary += 'Direction: ' + thresholds.target;
            if (thresholds && thresholds.packetLoss)
                summary += ' | Packet Loss: ' + thresholds.packetLoss;
            if (thresholds && thresholds.distance)
                summary += ' | Distance: ' + thresholds.distance;
            if (thresholds && thresholds.jitter)
                summary += ' | Jitter: ' + thresholds.jitter;
            if (thresholds && thresholds.congestion)
                summary += ' | Congestion: yes';
            return summary;
        },
        setExpiration: function(item,id){
            $scope.scopeSelection = {"item":item};
            $scope.$root.$emit("$openPopup","expirationEditor",id, {modal: true} );
        },
        servicesNames:{},
        specialActions: [
            {
                id: 'rule-addition',
                icon: 'add',
                tooltip:'Add',
                func:  function(selectedItems, tableConfig, $event) {
                    if (tableConfig.types) {
                        var targetElId = 'inner-action-rule-addition';
                        $scope.$root.toggleDropDown(targetElId, $event);
                    } else {
                        addNewRule(tableConfig, 'Disconnect');
                    }
                },
                innerActions: [{
                        icon: '',
                        name: 'Connectivity',
                        func: function(selectedItems, tableConfig) {
                            addNewRule(tableConfig, 'Disconnect');
                        }
                    }, {
                        icon: '',
                        name: 'Quality',
                        func: function(selectedItems, tableConfig) {
                            addNewQualityRule(tableConfig);
                        }
                    }
                ],
            },
            {
                'icon':'delete',
                'tooltip':'Delete',
                'func' : function(selectedItems,config) {
                    $scope.removeItems(selectedItems,config,ruleDef.removeURL);
                }
            },
            {
                'icon': 'disable',
                'tooltip':'Disable',
                func: function(selectedItems,config) {$scope.disableRules(selectedItems,true,config.exceptions);}
            },
            {
                'icon': 'enable',
                'tooltip':'Enable',
                func: function(selectedItems,config) {$scope.disableRules(selectedItems,false,config.exceptions);}
            }
        ],
        icons: icons,
        noReload:true,
        editTable:true,
        hasChanges: function(id){
            return $scope.$root.hasChanges(id);
        },
        typeProcessData : ruleDef.typeProcessData,
        getStatus:function(rule){
            if(!$scope.ignoreChanges){
                var status = "saved";
                if(rule.id < 0){
                    status = "new";
                }
                var origRule = $scope.origRules[rule.id];

                if (origRule && origRule.alertConstraint && origRule.alertConstraint.qualityConstraint)
                    origRule.alertConstraint.qualityConstraint.thresholdsLabel = rule.alertConstraint.qualityConstraint.thresholdsLabel;

                if(origRule && !angular.equals(rule,origRule)){
                    status = "changed";
                }
                rule.status = status;
                return status;
            }
            else{
                return rule.status;
            }
        },
        processData : function(items){
            if(typeof this.typeProcessData == "function"){
                this.typeProcessData(items);
            }
            items.forEach(function(item){
                item.status = "saved";
            });
            var orig = angular.copy(items);
            orig.forEach(function(rule){
                $scope.origRules[rule.id] = rule;
            });
        },
        noSearch: true,
        afterUpdate: function () {
            if (!this.dataURL()) {
                this.processData(this.items);
            }
        },
        parseData: ruleDef.parseData? ruleDef.parseData : function () {
            var that = this;
            if ($scope.account && $scope.account["rules"]) {
                // TODO below filtering code should be moved to back-end
                return $scope.account["rules"].filter
                (function (item)
                    {
                        return (!that.ruleAction || item.ruleAction === that.ruleAction) &&
                            (!item.systemRule  || item.systemRule && isSystemLogin);
                    });
            }
            return [];
        },
        toggleRuleStatus: function(item, disable){
            $scope.disableRules(item, disable, this.exceptions);
        },
        noDisable: true,
        sortField: 'lastModified',
        sortDir: 'DESC',
        ruleCollection: ruleDef.ruleCollection,
        fromText: ruleDef.fromText,
        noDirectionField: ruleDef.noDirectionField,
        customFields: ruleDef.customFields,
        ruleActions: ruleDef.ruleActions,
        actionData: ruleDef.actionData,
        changeAction: ruleDef.changeAction,
        actionsConfig: ruleDef.actionsConfig,
        setAction: ruleDef.setAction,
    };

    $scope.initItemsModal = function(modalType, itemType = '') {
        if (modalType === 'src') {
            $scope.showTabIpsPorts = itemType;
        }
        else {
            $scope.showTabIpsPortsApps = itemType;
        }
    };

    var getNewDefaultRule = function(ruleType, ruleAction) {
        return {
            source: [],
            destination: [],
            dest: [],
            apps: [],
            id: Math.floor((Math.random() * 100000000000000) + 1) * -1,
            ruleAction: ruleAction,
            healthType: ruleType,
            fileSize : $scope.defaultFileSize,
            enabled: true,
        };
    }

    var addNewRule = function(tableConfig, ruleType) {
        if (!tableConfig.items) {
            tableConfig.items = [];
        }

        var newRule = getNewDefaultRule(ruleType, tableConfig.ruleAction);

        tableConfig.items.unshift(newRule);

        if(_.find(ruleDef.fields, {path: 'dir'}) || (ruleDef.customFields && _.find(ruleDef.customFields, {path: 'dir'}))){
            tableConfig.items[0].dir = "TO";
        }
        tableConfig.refreshViewItems = new Date().getTime();

        return newRule;
    };

    var addNewQualityRule = function(tableConfig) {
        let item = addNewRule(tableConfig, 'Quality');

        // in case of quality rule we enforce critical alerts (user can't change it from the track dialog)
        item.trigger = 'ALERT';
        item.addresses = 'All Admins';
        item.alertFrequency = 'IMMEDIATE';
        item.alertConstraint = {
            qualityConstraint: {
                percentage: 80,
                percentageTimeFrame: 10,
                percentageTimeFrameType: 'MINUTES',
                clearTimeFrame: 5,
                clearTimeFrameType: 'MINUTES',
                thresholds: {
                    target: 'any'
                }
            }
        };
    };

    $scope.clearAlertConstraints = function(){
        $scope.occurrenceConstraint =  {};
        delete $scope.durationConstraint;
    };

    $scope.rulesConfigException = angular.extend({}, $scope.rulesConfig);
    $scope.rulesConfigException.exceptions = true;
    $scope.rulesConfigException.ruleAction = ruleDef.exceptionAction;


    $scope.specialErrorHandle = function(notification){
        if(notification.field.startsWith("fileSize")){
            notification.message = notification.message.replace("#maxFileSize#",$scope.maxFileSize );
        }
    };

    $scope.disableRules = function(selectedItems, isDisabled, exceptions) {
        if(!$scope.checkSelectedItems(selectedItems,isDisabled?"disable":"enable")) return;
        var message = isDisabled?"Rules were disabled":"Rules were enabled";
        var itemsToDisable= [];
        if(selectedItems instanceof Array){
            selectedItems.forEach(function(item){
                itemsToDisable.push(item.id);
            });
        }
        else {
            itemsToDisable.push(selectedItems.id);
        }

        var params = {};
        if ($state.params.accountId) {
            params.accountId = $state.params.accountId;
        }

        store.save({
            path: "/disableRules",
            data: {'rules':itemsToDisable,'disabled':isDisabled,'type':ruleType.toUpperCase()},
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                var targetConfig = exceptions? $scope.rulesConfigException : $scope.rulesConfig;
                targetConfig.items.forEach(function(rule) {
                    if(itemsToDisable.indexOf(rule.id) >= 0) {
                        rule.enabled = !isDisabled;
                    }
                });

                $scope.$root.handleServerResponse(data,"", message);
                if(data.status !== "ERROR"){
                    $scope[(exceptions?"exceptions":"") + "datamodified"] = new Date().getTime();
                }

            }
        });
    };


    $scope.allowAny = function(){
        $scope.scopeSelection["item"][$scope.scopeSelection["type"]] = [{"id":-1,"name":"Any","display_name":"Any"}];
        $scope.allowAnyItems = false;
    };


    $scope.selectedApps = [];

    $scope.selectApp = function(app){
        GeneralUtilsService.toggleSelection($scope.selectedApps,app.id);
    };

    $scope.addConstraints = function(){
        function isEmpty(map) {
           for(var key in map) {
              return !map.hasOwnProperty(key);
           }
           return true;
        }

        var item = $scope.scopeSelection.item;
        if(ruleDef.constraints.indexOf('service') >= 0 || ruleDef.constraints.indexOf('limit_bw') >= 0 || ruleDef.constraints.indexOf('time') >= 0 ||
            ruleDef.constraints.indexOf('ports') >= 0 || ruleDef.constraints.indexOf('custom_apps') >= 0){
            item.constraint.predicates = {};
            if(ruleDef.constraints.indexOf('service') >= 0 || ruleDef.constraints.indexOf('custom_apps') >= 0) {
                var selectedApps = [];
                $scope.serviceConstraintConfig.selectedItems.forEach(function(item) {
                    selectedApps.push(item.id);
                });
                $scope.customAppsConfig.selectedItems.forEach(function(item) {
                    selectedApps.push(item.id);
                });
                item.constraint.predicates = {"appid":{"field":{name:"appid"},"op":"OP_LE","values":selectedApps}};
            }

            if ($scope.portsConstraints) {
                $scope.portsConstraints.trim().split(",").forEach(function(port) {
                    port = port.trim();
                    if (port.indexOf("-") > 1) {
                        var ports = port.split("-");

                        var portInt1 = parseInt(ports[0]);
                        var portInt2 = parseInt(ports[1]);
                        if (!!portInt1 && portInt1 !== 0 && !!portInt2 && portInt2 !== 0 && portInt2 > portInt1) {
                        if (!item.constraint.predicates.ports_range) {
                            item.constraint.predicates.ports_range = {"field":{name:"ports_range"},"op":"OP_IR","values":[]}
                        }
                            item.constraint.predicates.ports_range.values.push(portInt1 + '-' + portInt2);
                        }
                    } else {
                        var portInt = parseInt(port);
                        if (!!portInt && portInt !== 0) {
                            if (!item.constraint.predicates.server_port) {
                                item.constraint.predicates.server_port = {"field":{name:"server_port"},"op":"OP_EQ","values":[]}
                            }
                            item.constraint.predicates.server_port.values.push(portInt.toString());
                        }
                    }
                });
            }

            if($scope.timeConstraints['type'] == "always"){
                delete item.constraint.predicates["time"];
            }
            else if($scope.timeConstraints['type'] == "workingHours"){
                item.constraint.predicates["time"] = {"field":{name:"time"},"op":"OP_EQ","values":["workingHours"]};
            }
            else { //custom
                item.constraint.predicates["time"] = {"field":{name:"time"},"op":"OP_EQ","values":[$scope.timeConstraints.timeDef]};
            }

            if(ruleDef.constraints.indexOf('limit_bw') >= 0) {
                if($scope.bwConstraints['download']) {
                    item.constraint.predicates["limit_bw"] =  {"field":{name:"limit_bw"},"op":"OP_GT","values":[parseInt($scope.bwConstraints['download'])]};
                }
            }
        }
        if(ruleDef.constraints.indexOf('connectivity') >= 0 || ruleDef.constraints.indexOf('quality') >= 0){
            item.alertConstraint = item.alertConstraint || {};

            if (item.healthType === 'Disconnect') {
                if($scope.durationConstraint && $scope.durationConstraint > 0){
                    item.alertConstraint.minDown = $scope.durationConstraint;
                }
                else if (item.alertConstraint.minDown > 0){
                    delete item.alertConstraint.minDown;
                }
                if($scope.occurrenceConstraint && !isEmpty($scope.occurrenceConstraint)){
                    item.alertConstraint.occurrenceConstraint = $scope.occurrenceConstraint;
                }
                else{
                    delete item.alertConstraint.occurrenceConstraint;
                }
            } else if (item.healthType === 'Quality') {
                if ($scope.qualityConstraint && !isEmpty($scope.qualityConstraint)) {
                    item.alertConstraint.qualityConstraint = $scope.qualityConstraint;
                }
                else {
                    delete item.alertConstraint.qualityConstraint;
                }
            }
        }

       /* if (ruleDef.constraints.indexOf('ports') >= 0) {
            item.constraints.predicates['server_port'] =   {"field":{name:"server_port"},"op":"OP_EQ","values":[parseInt($scope.portsConstraints)]};

        }*/

        $scope.$root.closePopup('constraintEditor');
    };


    $scope.checkSelectedItems = function(selectedItems,action){
        if(selectedItems.length == 0){
            $scope.$root.alert("Please select items to " + action);
            return false;
        }
        return true;
    };

    /**
     * validate that no default rule is found in
     *
     * system accounts are allowed to delete
     */
    function defaultRuleSelected(items) {
        var isSelected = false;

        if(!isSystemLogin){
            if(items){
                items.forEach(function (item) {
                    if(item.defaultRule)
                        isSelected = true;
                });
            }
        }

        return isSelected;
    }

    $scope.removeItems = function(selectedItems,config, path){
        var len = selectedItems.length;
        if(len == 0) {
            $scope.$root.alert("Please select items to delete");
            return;
        }

        if(defaultRuleSelected(selectedItems)){
            $scope.$root.alert("Deleting Cato predefined rules is not allowed, rule can be disabled");
            return;
        }

        var itemsToDelete = [];
        selectedItems.forEach(function(item){
            itemsToDelete.push(item.id);
        });
        var itemsMessage = len == 1?"one rule": len + " rules";
        $scope.$root.confirm("Are you sure you want to remove " +  itemsMessage + "?", function(){
            store.remove({
                path: path,
                type: ruleType,
                items: itemsToDelete,
                success: function(data) {
                    itemsToDelete.forEach(function(item){
                        var pos = null;
                        for(var i = 0 ; i < config.items.length ; i++) {
                            if(config.items[i].id == item){
                                pos = i;
                                break;
                            }
                        }
                        if(pos != null){
                            config.items.splice(pos,1);
                        }
                    });
                    config.selectedItems = [];

                    $scope.$root.handleServerResponse(data, "","Rules removed successfully");
                    config.refreshViewItems = new Date().getTime();
                }
            });
        });
    };


    // Traffic logging source
    $scope.addIpsPorts = function(){
    	// any item
    	if ($scope.allowAnyItems) {
    		$scope.allowAny();
    		$scope.$root.closePopup('addItem');
    		return;
    	}

        var curItems = [];
        // ip
        $scope.ipsConfig.selectedItems.split(',').forEach(function(item) {
            if(item){
                curItems = curItems.concat({"uniqueId":item, "name":item, "entityType":"IP", "type":"IP"});
            }
        });

        // os
        $scope.osConfig.selectedItems.forEach(function(item) {
            if(item){
                curItems = curItems.concat({"display_name":item.name, "uniqueId":item.id, "name":item.id, "entityType":"OS", "type":"OS"});
            }
        });

        var itemTypes = ["sites","subnets","accesslogins"];
        for(var key in itemTypes){
            var config = $scope[itemTypes[key] + "Config"];
            curItems = curItems.concat(config.selectedItems);
        }

        // add to selected item
        $scope.scopeSelection["item"][$scope.scopeSelection["type"]] = curItems;
        // close dialog
        $scope.$root.closePopup("addItem");
    };

    //  Traffic logging destination
    $scope.addIpsPortsApps = function(){
        	// any item
        	if ($scope.allowAnyItems) {
        		$scope.allowAny();
        		$scope.$root.closePopup('IpPortAndApp');
        		return;
        	}
        var curItems = [];
        // ip
        $scope.ipsConfig.selectedItems.split(',').forEach(function(item) {
            if(item){
                curItems = curItems.concat({"uniqueId":item, "name":item, "entityType":"IP", "type":"IP"});
            }
        });
        // port
        $scope.portsConfig.selectedItems.split(',').forEach(function(item) {
            if(item){
                curItems = curItems.concat({"uniqueId":item, "name":item, "entityType":"PORT", "type":"PORT"});
            }
        });

        // apps
        $scope.appsConfig.selectedItems.forEach(function(item) {
            curItems = curItems.concat({"uniqueId":item.id, "name":item.id, "entityType":"APPSTRING", "type":"APPSTRING"});
        });

        //custom apps
        $scope.customAppsConfig.selectedItems.forEach(function(item) {
            curItems = curItems.concat({"uniqueId":item.id, "name":item.id, "entityType":"APPSTRING", "type":"APPSTRING"});
        });

        //custom categories
        $scope.customCategoriesConfig.selectedItems.forEach(function(item) {
            curItems = curItems.concat({"uniqueId":item.id, "name":item.id, "entityType":"APPSTRING", "type":"APPSTRING"});
        });

        var itemTypes = ["sites","subnets","accesslogins"];
        for(var key in itemTypes){
            var config = $scope[itemTypes[key] + "Config"];
            curItems = curItems.concat(config.selectedItems);
        }

        // add to selected item
        $scope.scopeSelection["item"][$scope.scopeSelection["type"]] = curItems;

        // close dialog
        $scope.$root.closePopup("IpPortAndApp");
    };

    $scope.updateConnectivityRuleType = function() {
        // any item
        if ($scope.allowAnyItems) {
            $scope.allowAny();
            $scope.$root.closePopup('connectivity-rule-type-popup');
            return;
        }
        var curItems = [];

        var anyItems = $scope.connectivityRuleTypesConfig.selectedItems.filter(function(item) { return item.id === 'Any'});
        if (anyItems.length > 0) { // if any is selected, unselect others
            curItems.push(anyItems[0]);
        } else {
            $scope.connectivityRuleTypesConfig.selectedItems.forEach(function(item) {
                curItems.push(item);
            });
        }

        $scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
        $scope.$root.closePopup('connectivity-rule-type-popup');
    };

    $scope.sitesConfig = {
        titleSearch: true,
        dataURL : function(){
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return "/sites?accountId=" +  accountId ;
        },
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},
            {"label":"Address","path":"address","template":"<span>{{item.address}}</span>"}
        ],
        type : "Site",
        actions: [],
        selectedItems:[],
        pageSize:5
    };

    $scope.accessloginsConfig = {
        titleSearch: true,
        statusNames:{"DISABLED":"Disabled","ACTIVE":"Configured","SUSPENDED":"Suspended","NEW":"New","PENDING_USER_CONFIGURATION":"Invitation Sent"},
        loginNameById:{},
        dataURL : function(){
            var accountId = $scope.currentAccountId || $state.params.accountId;
            return "/logins?accountId=" + accountId;
        },
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}<span>"},
            {"label":"E-mail","path":"email"}
        ],
        type : "AccessLogin",
        actions: [],
        selectedItems:[],
        pageSize:5
    };

    $scope.groupsConfig = {
        titleSearch: true,
        dataURL : function(){
            var accountId = $scope.currentAccountId || $state.params.accountId;
            var systemGroupsLimit = ruleDef.systemGroupsLimit ? "&systemGroupsLimit=healthRule" : "";
            return "/groups?accountId=" + accountId + systemGroupsLimit;
        },
        fixedLayout: true,
        fields : [{"label":"Name","path":"name","template":"<span>{{item.prefix}}{{item.name}}</span>"},
            {"label":"Description","path":"description","template":"<span>{{item.description}}</span>"}
        ],
        type : "Group",
        actions: [],
        selectedItems:[],
        pageSize: 5,
    };

    $scope.subnetsConfig = {
        titleSearch: true,
        fixedLayout: true,
        dataURL : function(){
            var accountId = $scope.currentAccountId || $state.params.accountId;
            if ($scope.site && $scope.site.id)
                return "/subnets?siteId=" + $scope.site.id;
            return "/subnets?accountId=" + accountId;
        },
        fields :[
            {"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},
            {"label":"Site","path":"siteName","template":"<span>{{item.siteName}}</span>"},
            {"label":"Network","path":"interfaceName","template":"<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>"},
            {"label":"IP","path":"subnet","template":"<span>{{item.translatedSubnet}}</span>"}
        ],
        type : "Subnet",
        actions: [],
        selectedItems:[],
        pageSize:5
    };

    $scope.ipRangesConfig = {
        fixedLayout: true,
        titleSearch: 'Range',
        searchField: 'display_name',
        dataURL: function () {
            if ($scope.site && $scope.site.id)
                return "/getNetworks?isRequestFromOFE=1&siteId=" + $scope.site.id;
            return '/getNetworks?isRequestFromOFE=1&accountId=' + $state.params.accountId;
        },
        fields: [
            {label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
            {label: 'Site', path: 'siteName', template: '<span>{{item.siteName}}</span>'},
            {label: 'Interface', path: 'interfaceName', template: '<span>{{item.interfaceName}}</span>'},
            {label: 'Type', path: 'subnetType', template: '<span>{{item.subnetType | capitalize}}</span>'},
            {label: 'Range', path: 'subnet', template: '<span>{{item.translatedSubnet}}</span>'},
        ],
        type: 'IPRange',
        actions: [],
        selectedItems: [],
        pageSize: 5,

    };

    $scope.dsUserConfig = {
        titleSearch: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/getAllDsUsers?accountId=" + $state.params.accountId;
        },
        fields : [{"label":"Name","path":"Login Name","template":"<span>{{item.loginName}}</span>"},
                    {"label":"Subnet","path":"Full Name","template":"<span>{{item.fullName}}</span>"}
                ],
        processData: function(items){
//            fillSelectedItems($scope.tableConfig.items);
//            updateConfigSelectedItems($scope.hostConfig,items);
        },
        type : "DsUser",
        actions: [],
        selectedItems:[],
        pageSize:5

    };

    $scope.ipsConfig = {
        selectedItems:""
    };

    $scope.portsConfig = {
        selectedItems:""
    };

    $scope.osConfig = {
        titleSearch: true,
        dataURL : function(){
            return "/getOsList";
        },
        actions: [],
        pageSize:5,
        parseData : function(items){
            var returnItems = [];
            items.forEach(function(item) {
                returnItems.push({"id" : item.name, "name" : $scope.osMapping[item.name] || item.name});
            });
            return returnItems;
        },
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"}],
        selectedItems:[]
    };

    $scope.osMapping = {
        OS_ANDROID: 'Android',
        OS_LINUX: 'Linux',
        OS_WINDOWS: 'Windows',
        OS_IOS: 'iOS',
        OS_MAC: 'mac',
        OS_IPHONE: 'iPhone',
        OS_EMBEDDED: 'Embedded'
    };


    var basicConfig = {
        titleSearch: true,
        dataURL : function(){
            if(this.filtered){
                return "/categories?filtered=true&accountId=" + $state.params.accountId;
            }
            else{
                return "/categories?accountId=" + $state.params.accountId;
            }

        },
        actions: [],
        pageSize:5,
        sortField:"display_name",
        searchField:"display_name"
    };
    $scope.appsConfig = {
        titleSearch: true,
        fields : [{"label":"Name","path":"display_name","template":"<span>{{item.display_name}}</span>"},{"label":"Categories","path":"categories","template":"<span>{{item.categoriesDisplay}}</span>"}],
        type : "App",
        selectedItems:[]
    };

    $scope.customAppsConfig = {
        titleSearch: true,
        dataURL : function () {
            return "/getCustomApps?accountId=" + $state.params.accountId;
        },
        actions: [],
        pageSize:5,
        sortField:"name",
        searchField:"name",
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Category","path":"categoryId","template":"<span>{{item.categoryId | capitalize}}</span>"}],
        type : "CustomApp",
        parseData: function (data) {
            var items = [];
            for (var key in data) {
                var item = data[key];
                item.id = item.appId;
                item.display_name = item.name;
                items.push(item);
            }
            return items;
        },
        selectedItems:[]
    };

    $scope.customCategoriesConfig = {
        titleSearch: true,
        dataURL : function () {
            return "/getCustomCategories?accountId=" + $state.params.accountId;
        },
        actions: [],
        pageSize:5,
        sortField:"name",
        searchField:"name",
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Description","path":"description","template":"<span>{{item.description}}</span>"}],
        type : "CustomCategory",
        parseData: function (data) {
            var items = [];
            for (var key in data) {
                var item = data[key];
                item.display_name = item.name;
                items.push(item);
            }
            return items;
        },
        selectedItems:[]
    };

    $scope.categoriesConfig = {
        titleSearch: true,
        fields : [{"label":"Name","path":"display_name","template":"<span>{{item.display_name | capitalize}}</span>"}],
        type : "AppCategory",
        selectedItems:[]
    };

    $scope.fqdnConfig = {
        selectedItems:""
    };

    $scope.tldConfig = {
        selectedItems:""
    };
/*
    $scope.singleIpConfig = {
        selectedItems:""
    };*/

    $scope.servicesConfig = {
        titleSearch: true,
        fields : [
            {"label":"Name","path":"display_name","template":"<span>{{item.display_name}}</span>"},
            {"label":"Categories","path":"categories","template":"<span>{{item.categoriesDisplay}}</span>"}
        ],
        type : "Service",
        selectedItems:[]
    };

    $scope.countriesConfig = {
        fixedLayout: true,
        titleSearch: true,
        dataURL: function () {
            return '/getAllCountries';
        },
        fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' }],
        type: 'Country',
        actions: [],
        selectedItems: [],
        pageSize: 5,
    };

    $scope.connectivityRuleTypesConfig = {
        titleSearch: true,
        dataURL : function () {
            return '/connectivityRuleTypes?accountId=' + $state.params.accountId;
        },
        actions: [],
        pageSize:10,
        sortField:"name",
        searchField:"name",
        fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Description","path":"description","template":"<span>{{item.description}}</span>"}],
        type : "ConnectivityRuleType",
        selectedItems:[],
    };

    $scope.toggleDirection = function(item){
        if(!item.dir){
            item.dir = 'BOTH';
            return;
        }

        if(item.dir === 'BOTH'){
            item.dir = 'TO';
        }
        else {
            item.dir = 'BOTH';
        }
    };

    angular.extend($scope.categoriesConfig, basicConfig);
    angular.extend($scope.appsConfig, basicConfig);
    angular.extend($scope.servicesConfig, basicConfig);

    if(isSystemLogin) {
        $scope.isSystemLogin = true;
    }
}